import { useQuery } from '@tanstack/react-query';
import { fetchProductFees } from '../services/productFees';

export const productFeeKeys = {
    list: (productId: string) => ['smr-admin', 'product-fees', productId] as const,
};

export function useProductFeesQuery(productId: string | undefined) {
    return useQuery({
        queryKey: productFeeKeys.list(productId ?? ''),
        queryFn: () => fetchProductFees(productId!),
        enabled: !!productId,
    });
}
